export const PackagesData = [
  {
    name: "Platinum",
    tier: "platinum",
    amount: "min. 15.000 LEI",
    tickets: "150 de bilete",
    perks: [
      "Sigla pe ecranele digitale (LED) din puncte cheie din Timișoara",
      "Sigla pe toate materialele de promovare online (Facebook, Instagram, site, TikTok)",
      "Banner / roll-up la standul de vânzare în ziua evenimentului",
      "Materiale promoționale expuse la punctele de vânzare a biletelor",
      "Mențiune în comunicatele de presă (presă scrisă și online)",
      "Participare la Brunch-ul sponsorilor în ziua Cursei",
      "Reprezentant la înmânarea premiilor",
      "Sigla de aceeași mărime cu cea a organizatorilor",
      "Sigla pe biletele fizice și digitale",
    ],
  },
  {
    name: "Gold",
    tier: "gold",
    amount: "min. 10.000 LEI",
    tickets: "100 de bilete",
    perks: [
      "Sigla pe ecranele digitale (LED) din Timișoara",
      "Sigla pe toate materialele de promovare online",
      "Banner / roll-up la standul de vânzare",
      "Materiale promoționale la punctele de vânzare",
      "Mențiune în comunicatele de presă",
      "Participare la Brunch-ul sponsorilor",
    ],
  },
  {
    name: "Silver",
    tier: "silver",
    amount: "min. 5.000 LEI",
    tickets: "50 de bilete",
    perks: [
      "Sigla pe ecranele digitale (LED) din Timișoara",
      "Sigla pe toate materialele de promovare online",
      "Mențiune în comunicatele de presă",
      "Participare la Brunch-ul sponsorilor",
    ],
  },
  {
    name: "Bronze",
    tier: "bronze",
    amount: "min. 1.000 LEI",
    tickets: "10 bilete",
    perks: [
      "Sigla pe materialele de promovare online",
      "Mențiune în comunicatele de presă",
    ],
  },
  {
    name: "Premii",
    tier: "premii",
    amount: "produse / vouchere",
    tickets: "Sponsorizare în natură",
    perks: [
      "Sigla pe materialele de promovare online",
      "Mențiune în comunicatele de presă",
      "Dacă valoarea premiilor egalează unul dintre pachete, se oferă beneficiile pachetului respectiv",
    ],
  },
];
